import React, { memo, useEffect } from "react";
import CustomTabs from "components/common/tabs/CustomTabs";

import useReportTemplates from "./useReportTemplates";

import "./reportTemplates.css";
import { useDispatch } from "react-redux";
import { setTitle } from "app/store/transmission/slice/transmissionSlice";
import { TEMPLATES_TAB_VIEW_MAPPER } from "static/constants";

const ReportTemplates = () => {
  const { tabs, currentTab, onTabChange } = useReportTemplates();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setTitle({ title: TEMPLATES_TAB_VIEW_MAPPER[currentTab] }));
  }, [currentTab, dispatch]);

  return (
    <CustomTabs tabs={tabs} selectedTab={currentTab} onChange={onTabChange} />
  );
};

export default memo(ReportTemplates);
